import React, { useState, useEffect } from 'react';
import {
    Box,
    HStack,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    useDisclosure,
    Text,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalCloseButton,
    Button,


} from '@chakra-ui/react'

import Select from 'react-select'

import { fetchWrapper } from '../../helpers';
import PageLoader from '../../components/Loader/PageLoader';
import ParserForm from './CreateParser/CreateParser';
import { ModalHeader } from 'react-bootstrap';
import { LuCopy } from 'react-icons/lu';
import { toast } from 'react-toastify';

function MessageParserList() {

    const { isOpen, onOpen, onClose } = useDisclosure();
    const [copiedField, setCopiedField] = useState({ id: null, type: null });
    const [customer, setCustomer] = useState([]);
    const [isOpenEdit, setIsOpenEdit] = useState(false)
    const [list, setList] = useState([])
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(false);
    const [open, setIsOpen] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState({});

    useEffect(() => {

        LoadCustomerList()
    }, [])
    useEffect(() => {
        loadList();
    }, [selectedCustomer?.id])

    let filters = selectedCustomer?.id ? `?customer_id=${selectedCustomer?.id || 1}` : ""

    const loadList = async () => {
        setLoading(true)
        const url = `${process.env.REACT_APP_API_URL}/template-parser/list${filters}`;
        const data = await fetchWrapper.get(url)
        setList(data.data);
        setLoading(false)
    }

    const meEdit = (rs) => {
        setIsOpenEdit(true);
        setData(rs)
        onOpen()
    }
    const AddNewParser = (rs) => {
        setIsOpenEdit(false);
        setData({})
        onOpen()
    }


    const handleCopy = (type, rs) => {
        let textToCopy = "";

        if (type === "parser") {
            textToCopy = rs?.parser_id || "";
        } else if (type === "message_text") {
            textToCopy = rs?.TemplateMessage?.message || "";

        }

        navigator.clipboard.writeText(textToCopy);

        toast.success("Copied to clipboard")
    };

    const handleSelect = (type, rs) => {
        // If empty selection, reset the filter
        if (rs === '') {
            if (type === 'customer') {
                setSelectedCustomer('');
            }
            return;
        }

        const { id, name } = rs;
        if (type === 'customer') {
            setSelectedCustomer(rs);
        }
    };



    const LoadCustomerList = async () => {
        const url = `${process.env.REACT_APP_API_URL}/customer/list`;
        const data = await fetchWrapper.get(url)
        setCustomer(data.data);


    }


    return (
        <>

            <PageLoader isLoading={loading} />

            <div className="body_section">

                <HStack justifyContent="space-between">
                    <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>

                        <Text fontSize="32px" fontWeight="300" color="#000000" my="0px" fontFamily="'Open Sans', sans-serif">Message Parser</Text>
                        <Box display={"flex"}>
                            <Box w={200}>
                                <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    placeholder="Customer"
                                    isClearable={true}
                                    isSearchable={true}
                                    name="customer"
                                    options={customer}
                                    getOptionLabel={(e) => e.business_name}
                                    getOptionValue={(e) => e.id}
                                    onChange={(e) => handleSelect('customer', e || '')}
                                    value={selectedCustomer}
                                />

                            </Box>
                            <Button onClick={AddNewParser} bg="#2563eb" padding="20px" fontSize="14px" fontWeight="500" fontFamily="'Open Sans', sans-serif"
                                color="#fff" marginLeft={5}>Create New Parser</Button>
                        </Box>

                    </Box>

                    <Box>
                        <HStack>

                            <Box className='add_new_parser'>
                                <Modal size="5xl" isOpen={isOpen} onClose={onClose} >
                                    <ModalOverlay />
                                    <ModalContent p={5} >
                                        <ModalHeader style={{ fontWeight: "600", fontSize: "1.5rem" }}>Create New Parser</ModalHeader>
                                        <ModalCloseButton />
                                        <ParserForm setIsOpenEdit={setIsOpenEdit} isOpenEdit={isOpenEdit} data={data} onClose={onClose} loadList={loadList} />
                                    </ModalContent>

                                </Modal>
                            </Box>
                        </HStack>
                    </Box>
                </HStack>



                <div className="table_section">


                    <TableContainer width="100%">
                        <Table variant='simple' width="100%" borderWidth="1px" borderColor="#CCCCCC" borderStyle="solid">
                            <Thead >
                                <Tr>
                                    <Th>Parser ID</Th>
                                    <Th>Message Text</Th>
                                    <Th>Customer</Th>
                                    <Th>xNotify Template Name</Th>
                                    <Th>xNotify Message</Th>


                                </Tr>
                            </Thead>
                            {list.length > 0 ? <Tbody fontSize="14px">
                                {list.map((rs, index) => {
                                    return (

                                        <Tr key={`${rs?.id}-${rs?.parser_id}-${index}`}>
                                    
                                            <Td
                                                style={{ position: "relative", cursor: "pointer" }}

                                            >
                                                <div style={{ display: "flex", alignItems: "center" }}> <span style={{ cursor: 'pointer', color: "#2563eb" }} onClick={() => meEdit(rs)}>{rs?.parser_id}


                                                </span><LuCopy
                                                        title="Copy Parser ID"
                                                        onClick={() => handleCopy("parser", rs)}
                                                        style={{
                                                            marginLeft: "10px",
                                                            cursor: "pointer",
                                                            fontSize: "1rem",
                                                            color: "#4A5568"
                                                        }}
                                                    />
                                                </div>

                                            </Td>

                                            <Td whiteSpace="normal" wordBreak="break-word" maxW="300px">
                                                {rs?.sample_message}
                                            </Td>

                                            <Td>{rs?.Customer?.name}</Td>
                                            <Td>{rs?.TemplateMessage.name}</Td>

                                            <Td whiteSpace="normal" maxW="300px">
                                                <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap">
                                                    <Box flex="1" mr={2} wordBreak="break-word">
                                                        {rs?.TemplateMessage?.message}
                                                    </Box>
                                                    <LuCopy
                                                        title="Copy Parser ID"
                                                        onClick={() => handleCopy("message_text", rs)}
                                                        style={{
                                                            cursor: "pointer",
                                                            fontSize: "1rem",
                                                            color: "#4A5568",
                                                            flexShrink: 0,
                                                        }}
                                                    />
                                                </Box>
                                            </Td>

                                        </Tr>


                                    )
                                })}
                            </Tbody> : <Text>No data found</Text>}
                        </Table>
                    </TableContainer>
                </div>

            </div >
        </>
    )
}


export default MessageParserList
